const BRANDS: Record<string, { logo: string; name: string }> = {
  // PaisaPaid
  "d34e37c0-6e30-4cae-8ae2-b0bac2e56576": {
    logo: "https://marketing-content-images.s3.ap-south-1.amazonaws.com/paisapaid.jpeg",
    name: "PaisaPaid",
  },
  // Kissht
  "9490f878-415d-4d19-91cd-b126f7b7d979": {
    logo: "https://marketing-content-images.s3.ap-south-1.amazonaws.com/kissht.jpg",
    name: "Kissht",
  },
  // Vishtra Money
  "25d19710-d43e-4344-8c39-a74507002c09": {
    logo: "/v_money_new.png",
    name: "Vishtra Money",
  },
  // NearMeDeals
  "5ac6060e-bc66-4bdb-83b5-5d1897f7f65e": {
    logo: "https://marketing-content-images.s3.ap-south-1.amazonaws.com/LogoNew_White.png",
    name: "NearMeDeals",
  },
  // Coupl
  "2638e67d-30b4-4643-98a8-5ce858054104": {
    logo: "/coupl_logo.png",
    name: "Coupl",
  },
};

export const getWhitelabelAgentId = (): string => {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get("agentId") || params.get("agent_id");
  if (fromQuery) {
    try {
      localStorage.setItem("whitelabel_agent_id", fromQuery);
    } catch {}
    return fromQuery;
  }
  const fromStorage = localStorage.getItem("whitelabel_agent_id");
  if (fromStorage) {
    return fromStorage;
  }
  const loggedInAgentId = localStorage.getItem("agent_id") || "";
  if (loggedInAgentId && BRANDS[loggedInAgentId]) {
    try {
      localStorage.setItem("whitelabel_agent_id", loggedInAgentId);
    } catch {}
    return loggedInAgentId;
  }
  return "";
};

export const checkAndPersistWhitelabelAgentId = (agentId?: string | null) => {
  if (!agentId || typeof window === "undefined") return;
  if (BRANDS[agentId]) {
    try {
      localStorage.setItem("whitelabel_agent_id", agentId);
    } catch {}
  }
};

export const getBranding = () => {
  const agentId = getWhitelabelAgentId();
  return BRANDS[agentId] ?? null;
};

export const applyBrandingToDocument = () => {
  if (typeof window === "undefined") return;
  const brand = getBranding();
  if (brand) {
    document.title = `${brand.name} Portal`;
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((l) => {
      l.href = brand.logo;
    });
  } else {
    document.title = "DSA Portal";
  }
};
